<template>
  <div>
    <div class="form-isheader-group" v-loading="loading">
      <div class="form-isheader-group-content">
        <uploadimage :oldImageUrlList.sync="file_list" :imageUrlList.sync="upload_list" listType="picture-card"></uploadimage>
        <div class="flex-end" v-if="sumbmit_status">
          <el-button v-loading="btn_status" type="primary" @click="sumbit">提交保存</el-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import uploadimage from '@/components/Uploadimage.vue'
export default {
  components: {
    uploadimage,
  },
  props: ['order_id'],
  data () {
    return {
      sumbmit_status: false,
      btn_status: false,
      isreadonly: false,
      loading: true,
      showpicurl: '',
      showpicbox: false,
      old_file_list: [],
      upload_list: [],
      file_list: [],

    };
  },
  methods: {
    getdata () {
      this.loading = true;
      this.file_list = [];
      this.upload_list = [];
      this.old_file_list = [];
      this.post('/api/order/orderfiles', {
        order_id: this.order_id
      }).then((res) => {
        res.map((v) => {
          let file = {
            name: '',
						url:  this.apiurl + v.fileurl,
						fileurl: v.fileurl,
          }
          this.file_list.push(file);
          this.old_file_list.push(file);
        })
        this.loading = false;
      }).catch((err) => {
        console.log(err)
      })
    },
    sumbit () {
      this.btn_status = true;
      let upload_list = this.upload_list;
      let file_list = this.file_list;
      let id = this.order_id;
      let staff_id = this.sessionRead('staff_id');
      let data = { upload_list, file_list, id, staff_id };
      this.post('/api/order/upload_order_files', {
        ...data
      }).then((res) => {
        if (res.status == 'success') {
          this.$notify({
            showClose: true,
            message: '保存成功',
            type: 'success',
            offset: 160
          });
          this.getdata();
        } else {
          this.$notify({
            showClose: true,
            message: '保存失敗',
            type: 'error',
            offset: 160
          });
        }
        this.btn_status = false;
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  created () {
    this.getdata();
  },
  watch: {
    file_list: {
      handler: function (newVal, oldVal) {
        if (this.old_file_list.length != this.file_list.length) {
          this.sumbmit_status = true;
        }
      },
      deep: true
    },
    upload_list: {
      handler: function (newVal, oldVal) {
        if (newVal.length > 0) {
          this.sumbmit_status = true;
        } else {
          this.sumbmit_status = false;
        }
      },
      deep: true
    },
  }
}
</script>

<style scoped>
.flex-end{
	display:flex;
	justify-content: flex-end;
}
</style>
